import { css } from "styled-components";

export const centralized = css`
    max-width: 60vw;
    margin: auto;
    @media (max-width: 1480px) {
        max-width: 80vw;
    }
    @media (max-width: 1240px) {
        max-width: 90vw;
    } ;
`;

export const PlainTextStyle = css`
    font-family: "TT Commons Pro", sans-serif;
    font-size: 28px;
    font-weight: 300;
    @media (max-width: 1199px) {
        font-size: calc(20px + (8) * ((100vw - 320px) / (1200 - 320)));
    }
`;
